module.exports = __webpack_public_path__ + "static/media/resetBtn.9a627dbc.png";